export function loadImages() {
  const contactItem = document.querySelector('.contact-item')
  const projectItems = document.querySelectorAll('.project-item')
  const firstProjectItem = contactItem || projectItems[0]
  const isImage = firstProjectItem.dataset.image

  if (!isImage)
    return

  const screenWidth = Math.min(5120, window.innerWidth * window.devicePixelRatio)
  const screenHeight = Math.min(5120, window.innerHeight * window.devicePixelRatio)

  const widths = [720,1024,1280,1440,1600,1920,2048,2160,2560,2880,3200,3840,4096,5120]

  // Landscape: match screen width. Portrait (phone): match screen height since
  // a landscape image scaled to cover a portrait screen is constrained by height.
  const imagesWidth = screenWidth > screenHeight
    ? widths.find(width => width >= screenWidth) || 5120
    : widths.find(width => width >= screenHeight) || 5120

  if (contactItem) {

    const contactImageWidth = Math.max(1600, imagesWidth)

    contactItem.style.backgroundImage = 'url("/icons/loading9.gif")'
    contactItem.style.backgroundSize = 'auto'
    contactItem.style.backgroundPosition = 'center'
    contactItem.style.backgroundRepeat = 'no-repeat'
    contactItem.style.backgroundColor = '#000'
    contactItem.dataset.sizedImage = `/contacto3ve/${contactImageWidth}.jpg`
  }
  else {
    Array.from(projectItems).forEach(imageContainer => {
      const id = imageContainer.dataset.id
      const image = imageContainer.dataset.image

      if (image) {
        imageContainer.style.backgroundImage = 'url("/icons/loading9.gif")'
        imageContainer.style.backgroundSize = 'auto'
        imageContainer.style.backgroundPosition = 'center'
        imageContainer.style.backgroundRepeat = 'no-repeat'
        imageContainer.style.backgroundColor = '#000'
        imageContainer.dataset.sizedImage = `/uploads/project_item/image1/${id}/img${imagesWidth}_${image}`
      }
    })
  }
}
